import { useFlagStore } from '@/stores/flag';
import pinia from '@/stores/pinia';

/**
 * Check if the DM refactor flag is enabled
 * Safe to call from non-Vue contexts (constants, utils).
 * Uses the pinia instance directly to avoid requiring component setup context.
 *
 * TODO: DM_REFACTOR_2026 - Remove this util once refactor is complete.
 */
export function isDmRefactorEnabled() {
  try {
    const flagStore = useFlagStore(pinia);
    return flagStore.ready && flagStore.flags.communityDmRefactor;
  } catch {
    return false;
  }
}
